module.exports = __webpack_public_path__ + "static/media/bg.95a19da6.png";